import * as _ from 'underscore';
import { Module } from '../Module';
import { SiteRoles } from '../ServerApi/types/ISiteRole';
import { ServerService } from '../services/ServerService';

// TODO: hook this up in a bunch of other places.
export class SiteRolesResource {

  private static All = [
    SiteRoles.ServerAdministrator,
    SiteRoles.SiteAdministratorCreator,
    SiteRoles.SiteAdministratorExplorer,
    SiteRoles.SupportUser,
    SiteRoles.Creator,
    SiteRoles.ExplorerCanPublish,
    SiteRoles.Explorer,
    SiteRoles.Viewer,
    SiteRoles.Unlicensed,
    SiteRoles.Guest
  ];

  public static Mixed = 'Mixed';
  public static LocPrefix = 'siteRole_';
  public static Explorer = 'Explorer';

  public static $inject = ['ServerService'];

  constructor(private serverService: ServerService) {}

  public allOptions(): string[] {
    return SiteRolesResource.All;
  }

  public optionsForCurrentUser(): string[] {
    const rolesToRemoveFromList = [ SiteRoles.SupportUser, SiteRoles.Guest ];
    if (!this.serverService.isSessionServerAdmin()) {
      rolesToRemoveFromList.push(SiteRoles.ServerAdministrator);
    }
    return _.difference(this.allOptions(), rolesToRemoveFromList);
  }

  public optionsForCurrentUserExcept(...rolesToExclude: string[]): string[] {
    return _.difference(this.optionsForCurrentUser(), rolesToExclude);
  }

  public static isSiteAdmin(siteRole: string): boolean {
    return siteRole === SiteRoles.SiteAdministratorExplorer ||
           siteRole === SiteRoles.SiteAdministratorCreator ||
           siteRole === SiteRoles.SupportUser;
  }

  public static isSiteExplorerOrHigher(siteRole: string): boolean {
    return this.isSiteAdmin(siteRole) || siteRole === SiteRoles.ServerAdministrator || siteRole === SiteRoles.Creator || siteRole === SiteRoles.ExplorerCanPublish
    || siteRole === SiteRoles.Explorer;
  }

  public static isSiteCreatorOrHigher(siteRole: string): boolean {
    return this.isSiteAdmin(siteRole) || siteRole === SiteRoles.Creator;
  }

  public getProjectOwnershipRoles(): string[] {
    let projectOwnershipRoles = [
      SiteRoles.ServerAdministrator,
      SiteRoles.SiteAdministratorExplorer,
      SiteRoles.SupportUser,
      SiteRoles.ExplorerCanPublish
    ];
    if (this.serverService.hasCreatorTier()) {
      projectOwnershipRoles = projectOwnershipRoles.concat([SiteRoles.SiteAdministratorCreator, SiteRoles.Creator]);
    }

    return projectOwnershipRoles;
  }


  public getAdminRoles(): string[] {
    return _.compact([
        SiteRoles.ServerAdministrator,
        this.serverService.hasCreatorTier() && SiteRoles.SiteAdministratorCreator,
        SiteRoles.SiteAdministratorExplorer,
        SiteRoles.SupportUser
    ]);
  }
}

Module.instance().service('SiteRoles', SiteRolesResource);
